import {
    REQUEST_REDIRECT,
    UPDATE_TEMPLATE,
    UPDATE_ITEM_LIST,
    UPDATE_UNIT_LIST,
    UPDATE_ITEM_SMART_SUGGESTION_LIST,
} from '../ActionTypes'

const INITIAL_STATE = {
    redirectRequest: '',
    template: {},
    itemList: [],
    unitList: [],
    itemSmartSuggestionList: []
}

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case REQUEST_REDIRECT:
            return {...state, redirectRequest: action.payload }
        case UPDATE_TEMPLATE:
            return {...state, template: action.payload }
        case UPDATE_ITEM_LIST:
            return {...state, itemList: action.payload }
        case UPDATE_UNIT_LIST:
            return {...state, unitList: action.payload }
        case UPDATE_ITEM_SMART_SUGGESTION_LIST:
            return {...state, itemSmartSuggestionList: action.payload }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/TemplateEditPage/TemplateEditPageReducer.js